import React from 'react'
import PropTypes from 'prop-types'
import CollectionWithHeader from '../CollectionWithHeader'
import Color from './Color'

const CollectionColors = ({ title = '', errMessage = '', isLoading = false, colors, onClick }) => (
  <CollectionWithHeader title={title} errMessage={errMessage} isLoading={isLoading}>
    {colors.map(color => (
      <Color key={color} backgroundColor={color} onClick={() => onClick(color)} />
    ))}
  </CollectionWithHeader>
)

CollectionColors.propTypes = {
  title: PropTypes.string.isRequired,
  errMessage: PropTypes.string,
  isLoading: PropTypes.bool,
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClick: PropTypes.func.isRequired,
}

export default CollectionColors



// WEBPACK FOOTER //
// ./src/components/CollectionColors/index.js